import MenuBannerRecommendation from './MenuBannerRecommendation.vue';

export const menuBannerRecommendationRoutes = [
  { path: 'menu-banner-recommendation', component: MenuBannerRecommendation, name: 'menu-banner-recommendation' }
];
